import {REALTIME_DB} from '@/config/firebase';
import {get, ref} from 'firebase/database';

export const getUserInfo = (userId: string) => {
  // get field role, user_name, airline, aircraft
  const promiseArray = [
    get(ref(REALTIME_DB, `users/${userId}/role`)),
    get(ref(REALTIME_DB, `users/${userId}/user_name`)),
    get(ref(REALTIME_DB, `users/${userId}/airline`)),
    get(ref(REALTIME_DB, `users/${userId}/aircraft`))
  ];
  return Promise.all(promiseArray);
};
